exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heading[data-v-0b98e844]{max-width:60ch;margin:0;line-height:var(--heading-line-height)}.heading[data-v-0b98e844]:before{display:var(--heading-clamp);width:0;height:0;margin-top:calc((.8 - var(--heading-line-height))*0.5em);content:\"\"}", ""]);

// exports
